<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    top="100px"
    width="1224px"
    :before-close="handleClose"
    class="el-pass-dialog"
  >      
      <!-- <el-form :inline="true" :model="formInline" class="other-form-inline">
        <el-form-item>
          <el-input
            v-model="formInline.userName"
            placeholder="搜索名字"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="other-search" @click="onSubmit">
            <i class="el-icon-search"></i>
          </div>
        </el-form-item>
      </el-form> -->
      <div class="other-table">
        <el-table
          :data="tableData"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="500px"
        >
          <el-table-column prop="refuseReason" label="原因" min-width="140">
          </el-table-column>
          <el-table-column prop="createTime" label="操作时间" min-width="100">
          </el-table-column>
        </el-table>
      </div>
  </el-dialog>
</template>
<script>
import {
  selectRecommendAuditRecordList,
} from "@/apis/index";
// import { openFileUrl, formatFileType } from "@/utils/index";
// import { debounce } from "lodash";
// import {formatFileType} from "@/utils/index"
export default {
  data() {
    return {
      dialogVisible: false,
      loading:true,
      title: "",
      params: {},
      pageNation: {
      },
      tableData: [],
      userStateMap: {
        1: "在职",
        2: "离职",
        3: "公休",
      },
      formInline:{}
    };
  },
  methods: {
    showToggle(item) {
      this.pageNation = {
      }
      if (item.auditState == '3') {
        this.title = "简历审核不通过原因"
      }else if (item.auditState == '4'){
        this.title = "简历回退原因"
      }else if (item.auditState == '7'){
        this.title = "面试不通过原因"
      }
      this.title = "原因"
      this.dialogVisible = true;
      this.pageNation.recommendId = item.recommendId
      this.pageNation.auditState = item.auditState
      this.getData();
    },
    handleClose() {
      this.formInline = {}
      this.pageNation = {};
      this.dialogVisible = false;
    },
    async getData() {
      let params = this.pageNation
      params.pageNo = params.currentPage;
      const res = await selectRecommendAuditRecordList(params);
      if (res.code == 1) {
        this.tableData = res.data;
        this.loading = false;
      } else {
        this.$message.error(res.msg);
      }
    },
    onSubmit(){
      this.pageNation.userName = this.formInline.userName;
      this.getData();
    },
    expendClick() {
      this.expend = !this.expend;
    },
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0.5em;
  height: 0.5em;
}

/* 隐藏滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 隐藏滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: transparent;
}

</style>